import React, { useState, useEffect, Fragment } from "react";
import { TransactionStatus } from "../../Contexts/ChainbridgeContext";
import { Tag, Box, Flex } from "@chakra-ui/react";
import { Check, X } from "lucide-react";

interface IStepProgress {
  states: Array<TransactionStatus>;
  currentState: TransactionStatus;
}

type StepDisplayType = string | React.ReactElement;

const StepProgress: React.FC<IStepProgress> = ({
  states,
  currentState,
}: IStepProgress) => {
  const [lastStateSeen, setLastStateSeen] = useState<TransactionStatus>(
    states[0]
  );
  const iconSize = "12px";

  useEffect(() => {
    if (states.indexOf(currentState) >= 0) {
      setLastStateSeen(currentState);
    }
  }, [currentState]);

  return (
    <Flex justifyContent="space-between">
      {states.map((state) => {
        let stateIndex = states.indexOf(state);
        let currentStateIndex = states.indexOf(currentState);

        // If the current state doesn't match any of the listed states
        // we're in an error case.
        let didError = currentStateIndex < 0;

        // If we did error, rewrite the current state index to make things easier.
        currentStateIndex = didError
          ? states.indexOf(lastStateSeen)
          : currentStateIndex;

        let currentIsAtLastState = currentStateIndex == states.length - 1;

        let stateValue: StepDisplayType = (
          states.indexOf(state) + 1
        ).toString();

        // For all states we've completed, show a check
        if (stateIndex < currentStateIndex) {
          stateValue = <Check size={12} />;
        }

        // If we're at the current state, if we errored show an error.
        // If the current state is the last one, show a check.
        if (stateIndex == currentStateIndex) {
          if (didError) {
            stateValue = <X size={12} />;
          } else if (currentIsAtLastState) {
            stateValue = <Check size={12} />;
          }
        }

        let backgroundColor =
          stateIndex <= currentStateIndex ? "brand.800" : "brand.500";

        return (
          <Fragment key={"tag" + stateIndex}>
            <Tag.Root
              fontSize="12px"
              borderRadius="50%"
              variant="solid"
              backgroundColor={backgroundColor}
              color="white"
            >
              <Tag.Label>{stateValue}</Tag.Label>
            </Tag.Root>
            <Box
              height="1px"
              width="100%"
              display="block"
              mt="11px"
              backgroundColor={backgroundColor}
            ></Box>
          </Fragment>
        );
      })}
    </Flex>
  );
};

export default StepProgress;
